import React, { useContext } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import JobsPage from "../../Pages/JobsPage";
import DevJobsSotPage from "../../Pages/JobsPage/DevJobsSotPage";
import SignupPage from "../../Pages/SignupPage";
import Navigation from "../Navigation";
import LoginPage from "../../Pages/LoginPage";
import { AuthContext } from "../../Providers/UserProvider";
import { SHOP_JOBS_PATH } from "../../Providers/shopAuth";
import { SHOP_JOBS_DEV_PATH } from "../../Pages/JobsPage/jobsSurface";

export function AppRoutes({ user }) {
  return (
    <Switch>
      <Route path="/signup/:regionId/:shopId" component={SignupPage} />
      {user ? (
        <Route path="/" component={SignedInShell} />
      ) : (
        <Route path="/" component={SignedOutShell} />
      )}
    </Switch>
  );
}

function SignedInShell() {
  return (
    <>
      <Navigation />
      <Switch>
        <Route path={SHOP_JOBS_DEV_PATH} component={DevJobsSotPage} />
        <Route path={SHOP_JOBS_PATH} component={JobsPage} />
        <Redirect to={{ pathname: SHOP_JOBS_PATH }} />
      </Switch>
    </>
  );
}

function SignedOutShell() {
  return (
    <Switch>
      <Route path="/login" component={LoginPage} />
      <Redirect to={{ pathname: "/login" }} />
    </Switch>
  );
}

function Router() {
  const { user, initialized } = useContext(AuthContext);

  return (
    <div>
      {initialized ? (
        <BrowserRouter>
          <AppRoutes user={user} />
        </BrowserRouter>
      ) : (
        <div className="w-full h-full fixed block top-0 left-0 bg-white opacity-75 z-50">
          <span className="text-green-500 opacity-75 top-1/2 my-0 mx-auto block relative w-0 h-0">
            <i className="fas fa-circle-notch fa-spin fa-5x"></i>
          </span>
        </div>
      )}
    </div>
  );
}
export default Router;
